<template>
  <div class="container">
    <img src="@/assets/imgs/wiki/new-sensors.png" class="image" />
    <img src="@/assets/imgs/wiki/threadbare-sensors.png" class="image" />
  </div>
</template>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
  /* скрываем прокрутку только здесь */
  box-sizing: border-box;
  gap: 10px;
  padding: 0;
  margin: 0;
  padding-bottom: 15.6%
}

.image {
  margin-top: 20px;
  flex: 1;
  object-fit: cover;
}

/* Адаптация для маленьких экранов */
@media (max-width: 872px) {
  .container {
    flex-direction: column;
  }

  .image {

    height: auto;
  }
}
</style>
